export default __webpack_public_path__ + "static/media/img-17-kiano.a8b43bf8.jpg";